import React from "react";
import IdleTimer from "react-idle-timer";

type IdleTimerLogoutProps = {
  handleLogout: () => void;
};

export default function IdleTimerLogout({
  handleLogout,
}: IdleTimerLogoutProps) {
  const onIdle = () => {
    handleLogout();
  };

  return <IdleTimer onIdle={onIdle} timeout={1000 * 60 * 15} />;
}
